import statisticsActions from './actionTypes.js'
import Vue from 'vue'

const actions = {
  [statisticsActions.FETCH_STATISTICS]: async ({ dispatch }, { studyId, query }) => {
    const response = await Vue.axios.post(`/statistics/${studyId}/`, { query: query })
    return response
  }
}

export default {
  ...actions
}
